<div class="login">
  <div class="agreement-form">
    <div class="page-header">
      <div class="wrapper">
        <div class="logo"></div>
        <h3 translate>General user agreement</h3>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        @if (!agreementContainsUrl) {
          <div [innerHTML]="agreement"></div>
        }
        @if (agreementContainsUrl) {
          <div>
            <div><span translate>A warm welcome at</span>&nbsp;<strong [innerText]="portalName"></strong></div>
            <br>
              <span translate>Prior to accessing the site it is required to accept the terms of usage below.</span><br>
              <a target="_blank" download="" [href]="agreement" translate>Download agreement</a>
            </div>
          }
        </div>
      </div>

      <!--ACCEPTED CHECKBOX-->
      <div class="form-group">
        <div class="checkbox">
          <label>
            <input type="checkbox" [(ngModel)]="isAgreementAccepted">
            <span translate>Accepted</span>
          </label>
        </div>
      </div>


      <div class="row form-group">
        <!--CANCEL BUTTON-->
        <div class="col-md-6">
          <button class="btn btn-lg btn-block" (click)="onCancel()">
            <span translate>Cancel</span>
          </button>
        </div>
        <!--CONTINUE BUTTON-->
        <div class="col-md-6">
          <button class="btn btn-primary btn-lg btn-block" (click)="onAccept()" [disabled]="!isAgreementAccepted">
            <span translate>Continue</span>
          </button>
        </div>
      </div>

    </div>
  </div>